import { render, staticRenderFns } from "./FavoritesLayer.vue?vue&type=template&id=0c8889f7&scoped=true"
import script from "./FavoritesLayer.vue?vue&type=script&lang=js"
export * from "./FavoritesLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8889f7",
  null
  
)

export default component.exports